import { render } from "./mobile.vue?vue&type=template&id=e9d7bbbc&ts=true"
import script from "./mobile.vue?vue&type=script&lang=ts"
export * from "./mobile.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__